import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function FloatingBookButton() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleBookNow = (e: React.MouseEvent) => {
    if (location.pathname === '/booking') {
      e.preventDefault();
      const el = document.getElementById('reserve-spot');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div
      className={`fixed bottom-8 right-6 z-50 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <Link
        to="/booking#reserve-spot"
        onClick={handleBookNow}
        className="flex items-center gap-2 bg-brand-gold text-brand-black font-bold text-sm px-5 py-3.5 rounded-full shadow-lg hover:bg-brand-gold-dark hover:shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap animate-float"
      >
        <i className="ri-calendar-check-line text-base" />
        Book Now
      </Link>
    </div>
  );
}
